var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap login-white-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('div', {
    staticClass: "back-icon text-start"
  }, [_c('router-link', {
    staticClass: "ms-0",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(" Back")])], 1), _vm._m(0), _c('h4', {
    staticClass: "mb-4 ms-2"
  }, [_vm._v("Login with QR")]), _vm.showSpinnerLoader ? _c('div', [_c('spinners-loader')], 1) : _c('div', {
    staticClass: "auth-form-wrap login-smart-qr"
  }, [_c('div', [_c('div', {
    staticClass: "qr-image-container"
  }, [_vm.QRUrl ? _c('img', {
    staticClass: "mb-1",
    attrs: {
      "src": _vm.QRUrl
    }
  }) : _vm._e()]), !_vm.isQrCodeValid ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "retry-wrap",
    on: {
      "click": _vm.regenerateQRCode
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/regenerate.svg")
    }
  }), _vm._v("Regenerate "), _c('br'), _vm._v(" QR Code ")])]) : _c('div', [_c('OTPTimer', {
    attrs: {
      "title": "",
      "expirySecond": 180
    },
    on: {
      "sendOTP": _vm.getQR,
      "updateRemainingSecond": _vm.updateRemainingSecond
    }
  })], 1)])])])]), _vm._m(1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard-rep.svg"),
      "alt": "image-fluid"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding"
  }, [_c('div', {
    staticClass: "rep-dash-bg pt-3"
  }, [_c('div', {}, [_c('img', {
    staticClass: "mobile-screen",
    attrs: {
      "src": require("../../assets/images/mobile-ss.png")
    }
  })]), _c('div', {
    staticClass: "qr-login-list"
  }, [_c('h4', [_vm._v("Use representative dashboard on web:")]), _c('ul', {}, [_c('li', [_vm._v("Open Rep App on your phone.")]), _c('li', [_vm._v(" Tap QR Menu "), _c('img', {
    staticClass: "me-2 ms-2 qr-icon-bg",
    attrs: {
      "src": require("../../assets/images/qr-icon.svg"),
      "alt": "qr icon"
    }
  }), _vm._v(" located on top right of Rep App ")]), _c('li', [_vm._v("Point your phone to this screen to capture the QR code.")])])])])]);
}]

export { render, staticRenderFns }